import {PaymentMethodService} from "../resource";

const PaymentMethodModule = {
	namespaced: true,
	state: {
		datas: [],
		paymentMethodType : [
			{id:1,name:"โอนเงิน"},
			{id:2,name:"เก็บเงินปลายทาง"},
			// {id:3,name:"บัตรเครดิต"},
			{id:4,name:"เคลมสินค้า"},
			{id:5,name:"Rabbit Line Pay"},
			{id:6,name:"Platform"},
			{id:7,name:"อื่น ๆ"},
			]
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, data) {
			return PaymentMethodService.PaymentMethodCreate(data);
		},

		updateData({ commit, state }, data) {
			return PaymentMethodService.PaymentMethodUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return PaymentMethodService.PaymentMethodDelete(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await PaymentMethodService.PaymentMethodList(data);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				commit("SET_DATA", []);
			}
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		},
		getPaymentMethodTypeTableWithAll(state){
			return  [
			{id:0,name:"--- ประเภทการชำระเงิน --- "},...state.paymentMethodType ];
		},
		getPaymentMethodTypeTable(state){
			return state.paymentMethodType
		}
	},
};

export default PaymentMethodModule;